import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="price-table"
export default class extends Controller {
  connect() {
  }
}
